import { render, staticRenderFns } from "./ktgl-document-image.vue?vue&type=template&id=24fe84b2"
import script from "./ktgl-document-image.vue?vue&type=script&lang=ts"
export * from "./ktgl-document-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports